<template>
  <div class="rectangle">
    <h3 class="summary-title ml-20 pt-40 text-left text-uppercase">
      {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.summary") }}
    </h3>
    <!-- <h4 class="subtitle ml-20 mt-20 text-left" style="height: 27px">
      {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.agency") }}
    </h4> -->
    <div class="subtitle1 item mt-8 flex">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.payNow") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        {{ agencyBillableAmount }}
      </div>
    </div>
    <div
      v-if="agencyProduct.length > 0"
      class="subtitle1 item flex"
      style="color: rgba(39, 36, 33, 0.33)"
    >
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.saqFees") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        {{ agencyUnbillableAmount }}
      </div>
    </div>
    <div v-if="actionBar.country == 'QC'" class="subtitle1 item flex" style="color: rgba(39, 36, 33, 0.33)">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.subTotal") }}
      </div>
      <div class="mr-24 font-bold" style="margin-left: auto">
         <!-- <s>{{ subTotalDisp }}</s>   -->
         {{ subTotalBillable }}
      </div>
    </div>
    <h4 v-if="boutiqueProduct.length > 0"  class="subtitle ml-20 mt-20 text-left" style="height: 27px">
      {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.boutique") }}
    </h4>
    <div v-if="boutiqueProduct.length > 0"  class="subtitle1 item mt-8 flex">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.payNow") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        {{ botiqueBillableAmount }}
      </div>
    </div>
    <el-divider class="divider m-0 mt-7 mb-10 text-center" />
    <div v-if="actionBar.country != 'ON'" class="subtitle1 item flex">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.toPayNow") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        {{ totalpayableAmount }}
      </div>
    </div>

    <div v-if="actionBar.country == 'QC'" class="subtitle1 item flex">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.tps") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        <!-- <s>{{ tpsTaxTotal }}</s> -->
        {{ tpsTaxBillable }}
      </div>
    </div>
    <div v-if="actionBar.country == 'QC'" class="subtitle1 item flex">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.tvq") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        <!-- <s>{{ tvqTaxTotal }}</s> -->
        {{ tvqTaxBillable }}
      </div>
    </div>
    <div v-if="actionBar.country == 'ON'" class="subtitle1 item flex">
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.hst") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        <!-- <s>{{ tvqTaxTotal }}</s> -->
        {{ hstTaxTotal }}
      </div>
    </div>
    <el-divider class="divider m-0 mt-7 mb-10 text-center" />

    <div
      v-if="agencyProduct.length > 0"
      class="subtitle1 item flex"
      style="color: rgba(39, 36, 33, 0.33)"
    >
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.toPaySaq") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        {{ totalUnbillable }}
      </div>
    </div>
    <div
      class="subtitle1 item flex"
      style="font-weight: 700 !important; margin-top: 10px"
    >
      <div class="ml-20 text-left">
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.total") }}
      </div>
      <div class="mr-24" style="margin-left: auto">
        <!-- <s>{{ cartTotal }}</s> -->
        {{ totalbillableAmount }}
      </div>
    </div>
    <div class="text-right mr-24 mt-12" v-if="!isCheckOut">
      <el-button
        type="primary"
        class="button-dimension"
        @click="$emit('emit-checkout')"
      >
        {{ $i18n.t("shoppingCart.shoppingCartSummaryComponent.ctaOrder") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import { find, isEmpty, get, forEach} from "@/utils/lodash";

import { formatCurrency } from "@/utils/common-utils";

export default {
  props: {
    // products: {
    //   type: Object,
    //   default: () => {},
    // },
    shoppingCart: {
      type: Object,
      default: () => {},
    },
    cartListProduct: {
      default: () => [],
    },
    isCheckOut: {
      default: () => false,
    },
    cartSummaryData: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      total: 0,
      subTotal: 0,
      agencyProduct: {},
      boutiqueProduct: [],
      agencyProductTotal: 0,
      boutiqueProductTotal: 0,
      saqCharge: 34,
      agencyFees: 0,
      gst: 2.30,
      qst: 4.59,
      agencyFeesAmount: 0,
      taxIncluded: 'IN',
      agencyAmount: 0,
      boutiqueAmount: 0,
      totalAmount: this.getformatCurrency(0, this.$i18n.locale),
    };
  },
  computed: {
    ...mapGetters("user", ["isLoggedIn"]),
    ...mapState("configuration", ["actionBar"]),
    ...mapState("product", ["products"]),

    agencyBillableAmount() {
      let total = 0;

      // Filter agency products
      let agency = [];

      if (this.shoppingCart?.products && this.shoppingCart.products.length > 0) {
        agency = this.shoppingCart.products.filter(
          (p) =>
            p.puid != null &&
            p.product?.inventory?.code !== "STORE_MTL" &&
            p.product?.inventory?.code !== "STORE_QC"
        );
      } else if (Array.isArray(this.products?.results) && this.products.results.length > 0) {
        agency = this.products.results.filter(
          (p) =>
            p.puid != null &&
            p.inventory?.code !== "STORE_MTL" &&
            p.inventory?.code !== "STORE_QC"
        );
      }
      // Calculate total billable amount
      forEach(agency, (value) => {
        const product = find(
          this.cartSummaryData?.lines,
          (p) => { return p.product?.puid === value.puid }
        );
        if (!isEmpty(product)) {
          this.agencyProductTotal += get(product, "subTotalBrut", 0);
          total += get(product, "billableAmount", 0);
        }
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.agencyAmount = total;
      if(total == 0){
        total = this.cartSummaryData?.subTotalBillable;
      }      
      // Format and handle agencyProduct in localStorage
      const agencyAmount = this.getformatCurrency(total, this.$i18n.locale);
      localStorage.setItem("agencyProduct", total > 0);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.agencyFeesAmount = total;
      return agencyAmount;
    },
    agencyUnbillableAmount() {
      var total = 0;
      const agency = this.shoppingCart.products.filter((p) =>
        p.puid != null &&
        p.product?.inventory && p.product?.inventory?.code != "STORE_MTL" &&
        p.product?.inventory && p.product?.inventory?.code != "STORE_QC"
      );
      forEach(agency, (value) => {
        var product = find(this.cartSummaryData.lines, (p) => p.product.puid == value.puid);
        if (!isEmpty(product)) {
          total = total + get(product, "unbillableAmount", 0);
        }
      });
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    agencySubTotal(){
      var total = 0;
      const agency = this.shoppingCart.products.filter( (p) =>
          p.puid != null &&
          p.product?.inventory && p.product?.inventory?.code != "STORE_MTL" &&
          p.product?.inventory && p.product?.inventory?.code != "STORE_QC"
      );
      forEach(agency, (value) => {
        var product = find(this.cartSummaryData.lines, (p) => p.product.puid == value.puid);
        if(!isEmpty(product)){
          total = total + get(product, "unbillableAmount", 0);
          total = total + get(product, "billableAmount", 0);
        }
      });
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    cartTotal(){
      var total = get(this.cartSummaryData, "total", 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    cartTotalBillable(){
      var total = get(this.cartSummaryData, "totalBillable", 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    subTotalBillable(){
      var total = get(this.cartSummaryData, "totalUnbillable", 0);
      const country = localStorage.getItem("countryCode");
      if (country === "QC") {
        // const amount = total - this.agencyFeesAmount;
        // const amount = this.agencyProductTotal - this.agencyFeesAmount;
        return this.getformatCurrency(total, this.$i18n.locale);
      }
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    subTotalDisp(){
      var total = get(this.cartSummaryData, "subTotal", 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    botiqueBillableAmount() {
      let total = 0;
      let boutiqueProducts = [];

      if (this.shoppingCart?.products && this.shoppingCart.products.length > 0) {
        
        boutiqueProducts = this.shoppingCart.products.filter(
          (p) =>
            p.puid != null &&
            ["STORE_MTL", "STORE_QC", "STORE_TORONTO"].includes(p.product?.inventory?.code)
        );
      } 
      // else if (Array.isArray(this.products?.results) && this.products.results.length > 0) {
        
        boutiqueProducts = this.products.results.filter(
          (p) => 
            
              p.puid != null &&
              ["STORE_MTL", "STORE_QC", "STORE_TORONTO"].includes(p.inventory?.code)
          
        );
      forEach(boutiqueProducts, (value) => {
        const product = find(
          this.cartSummaryData?.lines,
          (p) => { return p.product?.puid === value.puid }
        );
        
        if (!isEmpty(product)) {
          total += get(product, "billableAmount", 0);
          this.boutiqueAmount = total;
        }
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.boutiqueProduct = boutiqueProducts;
      // Update localStorage and return formatted total
      localStorage.setItem("boutiqueProduct", total > 0);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.boutiqueProductTotal = total;
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    totalpayableAmount() {
      const amount = get(this.cartSummaryData, "subTotalBillable", 0);
      return this.getformatCurrency(amount, this.$i18n.locale);
    },

    tpsTaxTotal(){
      var total = get(find(this.cartSummaryData.taxes, (p) => p.label == 'TPS'), 'total', 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    tpsTaxBillable(){
      var total = get(find(this.cartSummaryData.taxes, (p) => p.label == 'TPS'), 'billable', 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    tvqTaxBillable(){
      var total = get(find(this.cartSummaryData.taxes, (p) => p.label == 'TVQ'), 'billable', 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    tvqTaxTotal(){
      var total = get(find(this.cartSummaryData.taxes, (p) => p.label == 'TVQ'), 'total', 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    hstTaxTotal() {
      const hstTax = get(find(this.cartSummaryData.taxes, (p) => p.label == 'GST/HST'), 'billable', 0);
      const total = hstTax;
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    totalBillable(){
      var total = get(this.cartSummaryData, "total", 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    totalUnbillable(){
      var total = get(this.cartSummaryData, "totalUnbillable", 0);
      return this.getformatCurrency(total, this.$i18n.locale);
    },
    totalbillableAmount() {
      let amount = get(this.cartSummaryData, "totalBillable", 0);
      const country = localStorage.getItem("countryCode");
      if (country === "ON") {
        amount = get(this.cartSummaryData, "total", 0);
      }
      this.botiqueBillableAmount;
      return this.getformatCurrency(amount, this.$i18n.locale)
    },
  },
  created() {
    this.agencyProducts();
    this.boutiqueProducts();
    this.updateAgencyBillable();
    this.getTotalAMount();
    this.$root.$on("changeTax", (tax) => {
      this.taxIncluded = tax.code;
      this.updateAgencyBillable();
      this.getTotalAMount();
    });
  }, 
  methods: {
    updateAgencyBillable() {
      this.agencyBillableAmountValue = this.agencyBillableAmount;
    },
    getTotalAMount() {
      this.totalAmount = this.totalbillableAmount
    },
    
    checkout(e) {
      this.$emit("emit-checkout", e);
    },
    agencyProducts() {
      // if (this.isLoggedIn == false) {
        if (this.products) {
          const getProducts = this.products;
          if (!getProducts) {
            this.agencyProducts = [];
            return;
          }
          this.agencyProducts = this.products.results.filter((p) => {
            return (
              p.puid != null &&
              p.inventory.code !== "STORE_MTL" &&
              p.inventory.code !== "STORE_QC"
            );
          });
        // }
        // }else {
          const shoppingCartProducts = this.shoppingCart?.products;
          
          if (!shoppingCartProducts) {
            this.agencyProducts = [];
            return; 
          }
          this.agencyProduct = this.cartListProduct?.results.filter(
            (p) =>{
              p.puid != null &&
              p.inventory && p.inventory.code != "STORE_MTL" &&
              p.inventory && p.inventory.code != "STORE_QC" &&
              p.inventory && p.inventory.code != "STORE_TORONTO"
            }
          );
        }
        localStorage.setItem("agencyProduct", this.agencyProduct.length > 0)
    },
    async boutiqueProducts() {
      this.boutiqueProduct = [];
      // if (this.isLoggedIn == false) {
        if (this.products) {

          const getProducts = this.products;
          if (!getProducts) {
            this.boutiqueProduct = [];
            return;
          }
          this.boutiqueProduct = this.products.results.filter((p) => {
            return (
              p.puid != null &&
              p.product?.inventory && p.inventory?.code === "STORE_MTL" &&
              p.product?.inventory && p.inventory?.code === "STORE_QC" &&
              p.product?.inventory && p.inventory?.code === "STORE_TORONTO"
            );
          });
        // }
      // } else {
        const shoppingCartProducts = this.shoppingCart?.products;
        if (!shoppingCartProducts) {
          this.boutiqueProduct = [];
          return;
        }
        this.boutiqueProduct = await this.cartListProduct?.results?.filter(
          (p) =>
            p.puid != null &&
            (p.inventory && p.inventory.code === "STORE_MTL" ||
            p.inventory && p.inventory.code === "STORE_QC") ||
            p.inventory && p.inventory.code === "STORE_TORONTO"
        );
      }
      localStorage.setItem("boutiqueProduct", this.boutiqueProduct.length > 0)
    },
    getformatCurrency(value = 0){
      return formatCurrency(value, this.$i18n.locale);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.rectangle {
  height: 544px;
  background-color: rgba(237, 240, 237, 0.33);
  box-sizing: border-box;

  // md +
  @media screen and (min-width: $media-md) {
    width: 388px;
  }
}
.subtitle {
  height: 27px;
  color: rgba(39, 36, 33, 0.7);
  letter-spacing: 0.25px;
}
.item {
  height: 26px;
  color: #272421;
  letter-spacing: 0.15px;
}
.divider {
  background-color: rgba(237, 240, 237, 1);
  margin-left: auto;
  margin-right: auto;
}
.button-dimension {
  height: 40px;
  width: 140px;
  font-size: 14px;
}
</style>
